import { yupResolver } from '@hookform/resolvers/yup';
import { joinAsyncTournamentValidationSchema } from './join-async-tournament-validation-schema';
import { useForm, UseFormReturn } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
interface FormFields {
  passphrase: string;
  isRewardBalanceSelected: boolean;
}
interface UseJoinTournamentTeamFormHook {
  form: UseFormReturn<FormFields>;
}

export const useJoinAsyncTournamentForm = (): UseJoinTournamentTeamFormHook => {
  const withPassphrase = useSelector(currentTournamentSelector.isPrivateTournament);

  const formResolver = yupResolver(joinAsyncTournamentValidationSchema(withPassphrase));
  const form = useForm<FormFields>({
    mode: 'onChange',
    resolver: formResolver,
    defaultValues: { passphrase: '', isRewardBalanceSelected: false },
  });

  return { form };
};
